import * as React from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import { getSettingPageMeta } from 'modules/settings/lib/getSettingPageMeta'

const PerformanceProcessSettings = React.lazy(
  () => import('modules/performance_process/pages/settings/PerformanceProcessSettings')
)
const settingRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.performanceProcess.path,
      element: <PerformanceProcessSettings />,
      handle: {
        meta: () => getSettingPageMeta(navigation, 'performance_process'),
      },
    },
  ]
}

export default settingRoutes
